module.exports = __webpack_public_path__ + "static/media/21ECLAC50.026a0a78.jpg";